module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALBAMAAABBvoqbAAAAIVBMVEUAAABZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGp1pZ+wAAAACnRSTlMAEte+xh7dzDEa4tEdhQAAACxJREFUCNdjaBZgYGCwUgQS4osmMDAweqkCmSLLAoDMVQZgFkgMLAtRB9YBAOONCD7iyocDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_next2.png
// module id = Vra6
// module chunks = 9